import { render, staticRenderFns } from "./historical-delegation-inquiry.vue?vue&type=template&id=0fbb7578&scoped=true&"
import script from "./historical-delegation-inquiry.vue?vue&type=script&lang=js&"
export * from "./historical-delegation-inquiry.vue?vue&type=script&lang=js&"
import style0 from "./historical-delegation-inquiry.vue?vue&type=style&index=0&id=0fbb7578&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbb7578",
  null
  
)

export default component.exports